import { forwardRef, type InputHTMLAttributes, type ReactNode } from "react";
import { cn } from "@/lib/cn";

export function inputBase(invalid?: boolean) {
  return cn(
    "h-11 w-full rounded-xl border bg-input px-3.5 text-sm text-fg transition-colors",
    "placeholder:text-fg-subtle",
    "focus-visible:outline-none focus-visible:border-primary focus-visible:ring-2 focus-visible:ring-ring/45",
    "disabled:cursor-not-allowed disabled:opacity-50",
    invalid ? "border-danger focus-visible:border-danger focus-visible:ring-danger/35" : "border-border",
  );
}

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
  leftIcon?: ReactNode;
  rightIcon?: ReactNode;
  wrapperClassName?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, leftIcon, rightIcon, wrapperClassName, ...props },
  ref,
) {
  if (!leftIcon && !rightIcon) {
    return (
      <input ref={ref} aria-invalid={invalid || undefined} className={cn(inputBase(invalid), className)} {...props} />
    );
  }
  return (
    <div className={cn("relative flex items-center", wrapperClassName)}>
      {leftIcon && (
        <span className="pointer-events-none absolute left-3 inline-flex text-fg-muted">{leftIcon}</span>
      )}
      <input
        ref={ref}
        aria-invalid={invalid || undefined}
        className={cn(inputBase(invalid), leftIcon && "pl-10", rightIcon && "pr-10", className)}
        {...props}
      />
      {rightIcon && <span className="absolute right-3 inline-flex text-fg-muted">{rightIcon}</span>}
    </div>
  );
});
